/*
 * @Author: qinmengyuan
 * @Date: 2024-04-08 18:00:29
 * @LastEditors: qinmengyuan 2715025514@qq.com
 * @LastEditTime: 2024-07-03 10:11:26
 * @FilePath: \onetab\src\constants\index.ts
 */
export const wallTypeList = {
  nature: [
    {
      name: 'bg1.webp',
      url: require('../background/nature/bg1.webp'),
    },
    {
      name: 'bg1.webp',
      url: require('../background/nature/bg2.webp'),
    },
    {
      name: 'bg1.webp',
      url: require('../background/nature/bg3.webp'),
    },
    {
      name: 'bg1.webp',
      url: require('../background/nature/bg4.webp'),
    },
    {
      name: 'bg1.webp',
      url: require('../background/nature/bg5.webp'),
    },
    {
      name: 'bg1.webp',
      url: require('../background/nature/bg6.webp'),
    },
  ],
  building: [],
  animal: [],
  travel: [],
};
